import d from "lodash";
import s from "react";
import e from "prop-types";
import i from "classnames";
import { u } from "./ThemeProvider--i7ESlT5.es.js";
import { d as c } from "./deprecate-Dt6BL0Y6.es.js";
import g from "./BaseToggle/index.es.js";
import './TextToggle.css';const n = "TextToggle-default-module__text___9IeEx", m = {
  text: n
}, f = "TextToggle-compere-module__text___ThKoz", x = {
  text: f
}, o = {
  default: m,
  compere: x
};
function a(t) {
  const r = u(), l = d.get(o, r, o.default);
  return /* @__PURE__ */ s.createElement(
    g,
    {
      ...t,
      leftValue: t.left.value,
      rightValue: t.right.value,
      icon: !1
    },
    /* @__PURE__ */ s.createElement(
      "span",
      {
        className: i(
          l.text,
          t.selectedValue === t.left.value ? l.selected : l.unselected
        )
      },
      t.left.text
    ),
    /* @__PURE__ */ s.createElement(
      "span",
      {
        className: i(
          l.text,
          t.selectedValue === t.right.value ? l.selected : l.unselected
        )
      },
      t.right.text
    )
  );
}
a.propTypes = {
  /** The object representing the left side of the toggle. */
  left: e.shape({
    text: e.string.isRequired,
    value: e.string.isRequired
  }).isRequired,
  /**  The object representing the right side of the toggle. */
  right: e.shape({
    text: e.string.isRequired,
    value: e.string.isRequired
  }).isRequired,
  /** This should be the same value as either **left.value**
   * or **right.value**, whichever you want selected by default
   */
  selectedValue: e.string.isRequired,
  /** This is the function called on toggle, it will pass the value
   * of whichever side is selected, either **left.value** or **right.value**
   */
  onToggle: e.func.isRequired,
  /** If true, toggle can not be toggled */
  disabled: e.bool,
  /** The color of the selected option. Available options are
   * 'red', 'gray', 'blue', 'green', 'purple' and 'lavender'
   * for default theme, and 'blue', 'green', 'purple' and 'pink'
   * for compere theme. If none given or incorrect theme/color combination,
   * the toggle color will default to a light gray.
   */
  color: e.string
};
a.defaultProps = {
  disabled: !1,
  color: void 0
};
const y = c(
  "TextToggle is deprecated. Use Toggle instead"
)(a);
export {
  y as W
};
